export class Database {
	static async getRandomJoke() {
		const jokes = [
			"Why do you never see hippos hiding in trees? Because they're really good at it.",
			'Why did the scarecrow win an award? Because he was outstanding in his field.',
			'I searched a list of ten puns to find one that made me laugh.... No pun in ten did',
			"Never tell a pun to a kleptomaniac. They're always taking things literally.",
			"What do you get when you cross a joke with a rhetorical question?",
			"Why do scuba divers fall backwards out of the boat? Because if they fell forwards they'd still be in the boat.",
			"What's orange and sounds like a parrot? A carrot.",
			"When does a joke become a dad joke? When the punchline becomes apparent. ",
			"My dog is a rescue, which is a really self righteous way of saying I bought a used dog"
		];

		return jokes[Math.floor(Math.random() * jokes.length)];
	}
}